export default __webpack_public_path__ + "static/media/Leaders_IMG-Leader-01A.eef4b96b.png";